import React  from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH, AUTHENTICATED_ENTRY,LIVE_STREAM_ENTRY } from 'configs/AppConfig'
import ViewService from 'services/ViewService';
import { message } from 'antd';

const PublicRoute = () => {
	const companyId= localStorage.getItem("companyId");
    const website= localStorage.getItem("website");
	const params= new URLSearchParams(window.location.search);
	const { token } = useSelector(state => state.auth)

	const handleAcceptMigration = async (shop, shopify_state)=>{
		try {
			const data= {
				shop_domain: shop,
				shopify_state
			}
			const response = await ViewService.acceptMigration(data);
			localStorage.setItem("x_request_source","SHOPIFY-APP");
            localStorage.setItem("shop_domain",true);
			return window.open(`${APP_PREFIX_PATH}/shopify/plans`,"_self");
		} catch (error) {
			message.error("error in accepting migration");
		}
	}

	const handleAcceptInstagramToken = async (instaToken, account_handle)=>{
		try {
			const payload= {
				userName: account_handle,
				token: instaToken
			}
			await ViewService.validateInstaToken(payload);
			message.success("Token is valid , redirecting to livestream page..");
			setTimeout(()=>{
				return window.open(`${APP_PREFIX_PATH}/live-call/stream/schedule`,"_self");
			},2000)
		} catch (error) {
			message.error("Token is invalid , redirecting to livestream page..");
			setTimeout(()=>{
				return window.open(`${APP_PREFIX_PATH}/live-call/stream/schedule`,"_self");
			},2000)
		}
	}

	function hasQueryParams(url) {
		const parsedUrl = new URL(url); // Parse the URL
		const params = parsedUrl.searchParams; // Get search parameters
		return [...params].length > 0; // Check if there are any query parameters
	}

	if(window.location.href.includes("/influencer")&&params.has("token")){
		if(token){
			return window.open(`${APP_PREFIX_PATH}/live-call/stream/schedule?token=${params.get("token")}&onboarded=influencer`,"_self");
		}
		else{
			return window.open(`${AUTH_PREFIX_PATH}/login?token=${params.get("token")}&onboarded=influencer`,"_self");
		}
	}
	if(window.location.href.includes("/aggregator")&&params.has("token")){
		if(token){
			return window.open(`${APP_PREFIX_PATH}/dashboards/default?token=${params.get("token")}&onboarded=aggregator`,"_self");
		}
		else{
			return window.open(`${AUTH_PREFIX_PATH}/login?token=${params.get("token")}&onboarded=aggregator`,"_self");
		}
	}
	if(window.location.href.includes("/instagram")&&params.has("token")&&params.has("state")){
		const stateParam= params.get("state");
		const decodedUrl= stateParam.replace(/-/g, '+').replace(/_/g, '/');
		const base64Decoded = atob(decodedUrl);
		const uint8ArrayDecoded = Uint8Array.from(base64Decoded, char => char.charCodeAt(0));
		const textDecoder = new TextDecoder();
		const decodedInstagramObj = JSON.parse(textDecoder.decode(uint8ArrayDecoded));
		if(decodedInstagramObj?.redirect && decodedInstagramObj?.redirect != null){
			const redirectUrl = decodedInstagramObj?.redirect;
			// Check if the URL has query parameters
			if (!hasQueryParams(redirectUrl)) {
				// If no query parameters exist, append `?`
				const redirectUrlWithParams = redirectUrl + `?token=${params.get("token")}&state=${params.get("state")}`;
				return window.open(redirectUrlWithParams, "_self");
			} else {
				// If query parameters already exist, append `&`
				const redirectUrlWithParams = redirectUrl + `&token=${params.get("token")}&state=${params.get("state")}`;
				return window.open(redirectUrlWithParams, "_self");
			}
		}
		else{
			if(token){
				console.log("token exists");
				const instaToken= params.get("token");
				handleAcceptInstagramToken(instaToken, decodedInstagramObj?.user_name);
			}
			else{
				console.log("token not exist");
				return window.open(`${AUTH_PREFIX_PATH}/login`,"_self");
			}
		}
	}
	else{
		if(token){
			if(params.has("shop") && params.has("shopify_state")){
				const shop= params.get("shop");
				const shopify_state= params.get("shopify_state");
				handleAcceptMigration(shop, shopify_state);
			}
			else{
				return <Navigate to={companyId=="2aebbd0722"||website=="influencer"?LIVE_STREAM_ENTRY:AUTHENTICATED_ENTRY} />
			}
		}
		else{
			return <Outlet/>
		}
	}
	
}

export default PublicRoute